import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import { TableRow, TableCell, Typography, makeStyles, Hidden, Badge } from '@material-ui/core';
import Status from "../../Common/BulletStatus";
import { setGradeColor } from '../../../utils/helpers';
import { TooltipRight } from "../../Common/CustomTooltips";
import t from "../../../languages/pl";
import LocalGasStationIcon from '@material-ui/icons/LocalGasStation';
import BuildIcon from "@material-ui/icons/Build";
import BlockIcon from '@material-ui/icons/Block';
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import {electricCarFuelTypeId} from "../../../config/constants";
import {propTypes} from "react-csv/lib/metaProps";

const useStyles = makeStyles((theme) => ({
  row: {},
  cell: {
    textAlign: "center",
  },
  ecoCell: {
    textAlign: "center",
    paddingLeft: theme.spacing(0.3)
  },
  badgeLocation: {
    right: -theme.spacing(1)
  },
  badgeColor: {
    background: theme.palette.primary.main,
  },
  fuelCell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  fuelLiters: {
    minWidth: 30
  },
  reserveIcon: {
    marginLeft: 15,
    color: 'orange'
  },
}));

const getRentStateBackground = (state) => {
  switch (state) {
    case t.unoccupied:
      return "#69E4A6";
    case t.rented:
      return "#FF5353";
    default:
      return "transparent";
  }
};

const getBatteryColor = (batteryLevel) => {
  if (+batteryLevel <= 11.5 && +batteryLevel >= 10.5) {
    return 'orange';
  } else if (+batteryLevel < 10.5) {
    return "#FF5353";
  }
};


const CarDetailsRow = props => {
  const defaultClasses = useStyles();
  const {
    registrationNo,
    archived,
    brand,
    model,
    description,
    blocade,
    service,
    ecoGrade,
    fuelLevel,
    fuelTypeId,
    fuelReserve,
    meterReading,
    state,
    onRowClick,
    onLastCellClick,
    classes = { ...defaultClasses },
    lastCellContent,
    onEcoGradeClick,
    gprs,
    poi,
    batteryCondition
  } = props;

  const handleEcoGradeClick = (e) => {
    e.stopPropagation();
    onEcoGradeClick && onEcoGradeClick();
  };

  const [fuelLevelLabel, setFuelLevelLabel] = useState('');

  useEffect(() => {
    const levelLabel = fuelTypeId === electricCarFuelTypeId ? `${fuelLevel}% ` : `${fuelLevel} l`;
    setFuelLevelLabel(levelLabel);
  }, [fuelTypeId]);

  const getServiceBlockadeLabel = (service, blockade) => {
    if (service) {
      return (
        <div style={{
          color: '#d88a18',
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          flexDirection: "column"
        }}>
          <BuildIcon style={{
            marginRight: 4, fontSize: 18
          }}/>
          {t.service}
        </div>);
    } else if (blockade) {
      return (
        <div style={{
          color: 'red',
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          flexDirection: "column"
        }}>
          <BlockIcon style={{ marginRight: 4, fontSize: 18 }}/>
          {t.blockade}
        </div>);
    }

    return (<span>-</span>);

  };


  return (
    <TableRow
      className={classes.row}
      onClick={onRowClick}
    >
      <TableCell className={classes.cell}>
        <Typography
          variant="body1"
        >
          <TooltipRight
            title={t.vehicleArchived}
            disable={!archived}
          >
            <Badge
              badgeContent="A"
              color="primary"
              invisible={!archived}
              classes={{
                anchorOriginTopRightRectangle: defaultClasses.badgeLocation,
                colorPrimary: defaultClasses.badgeColor
              }}
            >
              {registrationNo}
            </Badge>
          </TooltipRight>
        </Typography>
      </TableCell>
      <TableCell className={classes.cell}>
        <Typography
          variant="body1"
        >
          {brand}
        </Typography>
      </TableCell>
      <TableCell className={classes.cell}>
        <Typography
          variant="body1"
        >
          {model}
        </Typography>
      </TableCell>
      <TableCell className={classes.cell}>
        <Typography
          variant="body1"
        >
          {description}
        </Typography>
      </TableCell>
      <TableCell className={defaultClasses.ecoCell}>
        <TooltipRight title={t.showEcoChart} disable={ecoGrade === null}>
          <Status
            background={setGradeColor(ecoGrade)}
            onClick={handleEcoGradeClick}
          >
            {typeof (ecoGrade) === "number" ? ecoGrade === -1 ? 'b.d.' : ecoGrade.toFixed(2) : '-'}
          </Status>
        </TooltipRight>
      </TableCell>
      <TableCell className={classes.cell}>
        <div className={defaultClasses.fuelCell}>
          <Typography
            className={defaultClasses.fuelLiters}
            variant="body1"
          >
            {fuelLevelLabel}
          </Typography>
          {fuelReserve
            ?
            <LocalGasStationIcon
              className={defaultClasses.reserveIcon}
            />
            : null
          }
        </div>
      </TableCell>
      <Hidden mdDown>
        <TableCell className={classes.cell}>
          <Typography
            variant="body1"
            style={{ color: getBatteryColor(batteryCondition) }}
          >
            {batteryCondition + ' V'}
          </Typography>
        </TableCell>
        <TableCell className={classes.cell}>
          <Typography
            variant="body1"
          >
            {typeof (meterReading) === "number" ? meterReading === -1 ? 'b.d.' : meterReading : '-'}&nbsp;km
          </Typography>
        </TableCell>
        <TableCell className={classes.cell}>
          {getServiceBlockadeLabel(service, blocade)}
        </TableCell>
        <TableCell className={classes.cell}>
          <Typography
            variant="body1"
          >
            {gprs}
          </Typography>
        </TableCell>
        <TableCell className={classes.cell}>
          <Typography
            variant="body1"
          >
            {poi}
          </Typography>
        </TableCell>
        <TableCell className={classes.cell}>
          <Typography
            variant="body1"
          >
            <Status
              background={getRentStateBackground(state)}
            >
              {state}
            </Status>
          </Typography>
        </TableCell>
      </Hidden>
      <TableCell
        className={classes.cell}
        style={{ cursor: "pointer" }}
        onClick={onLastCellClick}
      >
        {lastCellContent}
      </TableCell>
    </TableRow>
  );
};

export default CarDetailsRow;

CarDetailsRow.propTypes = {
  registrationNo: PropTypes.string,
  archived: PropTypes.bool,
  brand: PropTypes.string,
  model: PropTypes.string,
  description: PropTypes.string,
  service: PropTypes.bool,
  blocade: PropTypes.bool,
  gprs: PropTypes.element,
  ecoGrade: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fuelLevel: PropTypes.number,
  fuelTypeId: PropTypes.number,
  fuelReserve: PropTypes.bool,
  meterReading: PropTypes.number,
  state: PropTypes.string,
  opened: PropTypes.bool,
  onRowClick: PropTypes.func,
  onLastCellClick: PropTypes.func,
  classes: PropTypes.object,
  lastCellContent: PropTypes.node,
  onEcoGradeClick: PropTypes.func,
  poi: PropTypes.string,
  batteryCondition: PropTypes.number,
};
